import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmGenerate = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "icon-llm-generate",
    "data-icon": "icon-llm-generate",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: [jsx("path", {
      d: "M20.25 12V16.5",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M18 14.25H22.5",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M7.5 3.75V8.25",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M5.25 6H9.75",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M15.75 17.25V20.25",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M14.25 18.75H17.25",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M13.5 7.5L16.5 10.5",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M17.0301 3.96951L3.96942 17.0302C3.67652 17.3231 3.67652 17.798 3.96942 18.0909L5.90844 20.0299C6.20133 20.3228 6.6762 20.3228 6.9691 20.0299L20.0298 6.96919C20.3227 6.6763 20.3227 6.20142 20.0298 5.90853L18.0908 3.96951C17.7979 3.67662 17.323 3.67662 17.0301 3.96951Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconLlmGenerate.displayName = 'IconLlmGenerate';

export { IconLlmGenerate };
//# sourceMappingURL=llm-generate.js.map
